var map = {
	"./act": 1450,
	"./act.ts": 1450,
	"./gmat": 1451,
	"./gmat.ts": 1451,
	"./gre": 1452,
	"./gre.ts": 1452,
	"./ielts": 1453,
	"./ielts.ts": 1453,
	"./ielts_general_training": 1454,
	"./ielts_general_training.ts": 1454,
	"./lsat": 1455,
	"./lsat.ts": 1455,
	"./mcat": 1456,
	"./mcat.ts": 1456,
	"./sat": 1457,
	"./sat.ts": 1457,
	"./toefl": 1458,
	"./toefl.ts": 1458
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2487;
module.exports = webpackAsyncContext;